import { useIntl } from 'react-intl';
import { ProgressCircle } from 'client/components/aria/Loading';

import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

import styles from './LoadingScreen.module.scss';
import PropTypes from 'prop-types';

const LoadingScreen = ({ delay, ...props }) => {
    const intl = useIntl();

    const classNames = [styles.container];
    if (delay) {
        classNames.push(styles.delayed);
    }

    return (
        <div className={classNames.join(' ')} role="alert" {...props}>
            <span className="govuk-visually-hidden">{intl.formatMessage({ id: 'loading' })}</span>
            <ProgressCircle
                data-testid={props['data-testid'] + '.progress'}
                isIndeterminate
                size={125}
            />
            <h1
                className="govuk-caption-xl govuk-!-font-size-48"
                data-testid={props['data-testid'] + '.title'}
            >
                {intl.formatMessage({ id: 'loading' }) + '...'}
            </h1>
        </div>
    );
};

LoadingScreen.propTypes = {
    ...defaultAriaProps,
    delay: PropTypes.bool
};

LoadingScreen.defaultProps = {
    'data-testid': 'loadingScreen',
    delay: false
};

export default LoadingScreen;
